// const Image1 = require("./resource/icon/0x00193007.png");
// const Image2 = require("./resource/icon/0x00193007-1.png");
// const Image3 = require("./resource/icon/0x00193007-2.png");
// const Image4 = require("./resource/icon/0x00210003.png");
// const Image5 = require("./resource/icon/0x00210003-1.png");
// const Image6 = require("./resource/icon/0x00210003-2.png");
// const Image7 = require("./resource/icon/0x001F0005.png");
// const Image8 = require("./resource/icon/0x001F0005-1.png");
// const Image9 = require("./resource/icon/0x001F0005-2.png");
// const Image10 = require("./resource/icon/0x001F0004.png");
// const Image11 = require("./resource/icon/0x001F0004-1.png");
// const Image12 = require("./resource/icon/0x001F0004-2.png");
// const Image13 = require("./resource/icon/0x00010904.png");
// const Image14 = require("./resource/icon/0x00010904-1.png");
// const Image15 = require("./resource/icon/0x00010904-2.png");
// const Image16 = require("./resource/icon/0x00210002.png");
// const Image17 = require("./resource/icon/0x00210002-1.png");
// const Image18 = require("./resource/icon/0x00210002-2.png");
// const Image19 = require("./resource/icon/0x02000201.png");
// const Image20 = require("./resource/icon/0x02000201-1.png");
// const Image21 = require("./resource/icon/0x02000201-2.png");
// const Image22 = require("./resource/icon/0x00193006.png");
// const Image23 = require("./resource/icon/0x00193006-1.png");
// const Image24 = require("./resource/icon/0x00193006-2.png");
// const Image25 = require("./resource/icon/0x03000302.png");
// const Image26 = require("./resource/icon/0x03000302-1.png");
// const Image27 = require("./resource/icon/0x03000302-2.png");
// const Image28 = require("./resource/icon/0x00160519_.png");
// const Image29 = require("./resource/icon/0x00160519_-1.png");
// const Image30 = require("./resource/icon/0x00160519_-2.png");
// const Image31 = require("./resource/icon/0x02000203.png");
// const Image32 = require("./resource/icon/0x02000203-1.png");
// const Image33 = require("./resource/icon/0x02000203-2.png");
// const Image34 = require("./resource/icon/0x001F0006.png");
// const Image35 = require("./resource/icon/0x001F0006-1.png");
// const Image36 = require("./resource/icon/0x001F0006-2.png");
// const Image37 = require("./resource/icon/0x001A3002.png");
// const Image38 = require("./resource/icon/0x001A3002-1.png");
// const Image39 = require("./resource/icon/0x001A3002-2.png");
// const Image40 = require("./resource/icon/0x00210001.png");
// const Image41 = require("./resource/icon/0x00210001-1.png");
// const Image42 = require("./resource/icon/0x00210001-2.png");
// const Image43 = require("./resource/icon/0x02000202.png");
// const Image44 = require("./resource/icon/0x02000202-1.png");
// const Image45 = require("./resource/icon/0x02000202-2.png");
// const Image46 = require("./resource/icon/0x00193005.png");
// const Image47 = require("./resource/icon/0x00193005-1.png");
// const Image48 = require("./resource/icon/0x00193005-2.png");
// const Image49 = require("./resource/icon/0x03000301.png");
// const Image50 = require("./resource/icon/0x03000301-1.png");
// const Image51 = require("./resource/icon/0x03000301-2.png");
// const Image52 = require("./resource/icon/0x00193001.png");
// const Image53 = require("./resource/icon/0x00193001-1.png");
// const Image54 = require("./resource/icon/0x00193001-2.png");
// const Image55 = require("./resource/icon/0x03000305.png");
// const Image56 = require("./resource/icon/0x03000305-1.png");
// const Image57 = require("./resource/icon/0x03000305-2.png");
// const Image58 = require("./resource/icon/0x02000206.png");
// const Image59 = require("./resource/icon/0x02000206-1.png");
// const Image60 = require("./resource/icon/0x02000206-2.png");
// const Image61 = require("./resource/icon/0x00010903.png");
// const Image62 = require("./resource/icon/0x00010903-1.png");
// const Image63 = require("./resource/icon/0x00010903-2.png");
// const Image64 = require("./resource/icon/0x001F0003.png");
// const Image65 = require("./resource/icon/0x001F0003-1.png");
// const Image66 = require("./resource/icon/0x001F0003-2.png");
// const Image67 = require("./resource/icon/0x001F0002.png");
// const Image68 = require("./resource/icon/0x001F0002-1.png");
// const Image69 = require("./resource/icon/0x001F0002-2.png");
// const Image70 = require("./resource/icon/0x00010902.png");
// const Image71 = require("./resource/icon/0x00010902-1.png");
// const Image72 = require("./resource/icon/0x00010902-2.png");
// const Image73 = require("./resource/icon/0x03000304.png");
// const Image74 = require("./resource/icon/0x03000304-1.png");
// const Image75 = require("./resource/icon/0x03000304-2.png");
// const Image76 = require("./resource/icon/0x03000306.png");
// const Image77 = require("./resource/icon/0x03000306-1.png");
// const Image78 = require("./resource/icon/0x03000306-2.png");
// const Image79 = require("./resource/icon/0x02000205.png");
// const Image80 = require("./resource/icon/0x02000205-1.png");
// const Image81 = require("./resource/icon/0x02000205-2.png");
// const Image82 = require("./resource/icon/0x00010900.png");
// const Image83 = require("./resource/icon/0x00010900-1.png");
// const Image84 = require("./resource/icon/0x00010900-2.png");
// const Image85 = require("./resource/icon/0x001F0001.png");
// const Image86 = require("./resource/icon/0x001F0001-1.png");
// const Image87 = require("./resource/icon/0x001F0001-2.png");
// const Image88 = require("./resource/icon/0x00010901.png");
// const Image89 = require("./resource/icon/0x00010901-1.png");
// const Image90 = require("./resource/icon/0x00010901-2.png");
// const Image91 = require("./resource/icon/0x02000204.png");
// const Image92 = require("./resource/icon/0x02000204-1.png");
// const Image93 = require("./resource/icon/0x02000204-2.png");
// const Image94 = require("./resource/icon/0x03000307.png");
// const Image95 = require("./resource/icon/0x03000307-1.png");
// const Image96 = require("./resource/icon/0x03000307-2.png");
// const Image97 = require("./resource/icon/0x02000303.png");
// const Image98 = require("./resource/icon/0x02000303-1.png");
// const Image99 = require("./resource/icon/0x02000303-2.png");
// const Image100 = require("./resource/icon/0x0016051A.png");
// const Image101 = require("./resource/icon/0x0016051A-1.png");
// const Image102 = require("./resource/icon/0x0016051A-2.png");
// const Image103 = require("./resource/icon/0x0016050D.png");
// const Image104 = require("./resource/icon/0x0016050D-1.png");
// const Image105 = require("./resource/icon/0x0016050D-2.png");
// const Image106 = require("./resource/icon/0x00160502.png");
// const Image107 = require("./resource/icon/0x00160502-1.png");
// const Image108 = require("./resource/icon/0x00160502-2.png");
// const Image109 = require("./resource/icon/0x02000302.png");
// const Image110 = require("./resource/icon/0x02000302-1.png");
// const Image111 = require("./resource/icon/0x02000302-2.png");
// const Image112 = require("./resource/icon/0x0016051B.png");
// const Image113 = require("./resource/icon/0x0016051B-1.png");
// const Image114 = require("./resource/icon/0x0016051B-2.png");
// const Image115 = require("./resource/icon/0x0016050F.png");
// const Image116 = require("./resource/icon/0x0016050F-1.png");
// const Image117 = require("./resource/icon/0x0016050F-2.png");
// const Image118 = require("./resource/icon/0x00160501.png");
// const Image119 = require("./resource/icon/0x00160501-1.png");
// const Image120 = require("./resource/icon/0x00160501-2.png");
// const Image121 = require("./resource/icon/0x02000301.png");
// const Image121Relate = require("./resource/icon/0x02000301-relate.png");
// const Image122 = require("./resource/icon/0x02000301-1.png");
// const Image123 = require("./resource/icon/0x02000301-2.png");
// const Image124 = require("./resource/icon/0x0016050C.png");
// const Image125 = require("./resource/icon/0x0016050C-1.png");
// const Image126 = require("./resource/icon/0x0016050C-2.png");
// const Image127 = require("./resource/icon/0x00160511.png");
// const Image128 = require("./resource/icon/0x00160511-1.png");
// const Image129 = require("./resource/icon/0x00160511-2.png");
// const Image130 = require("./resource/icon/0x00160510.png");
// const Image131 = require("./resource/icon/0x00160510-1.png");
// const Image132 = require("./resource/icon/0x00160510-2.png");
// const Image133 = require("./resource/icon/0x0016050B.png");
// const Image134 = require("./resource/icon/0x0016050B-1.png");
// const Image135 = require("./resource/icon/0x0016050B-2.png");
// const Image136 = require("./resource/icon/0x001C3003.png");
// const Image137 = require("./resource/icon/0x001C3003-1.png");
// const Image138 = require("./resource/icon/0x001C3003-2.png");
// const Image139 = require("./resource/icon/0x02000306.png");
// const Image140 = require("./resource/icon/0x02000306-1.png");
// const Image141 = require("./resource/icon/0x02000306-2.png");
// const Image142 = require("./resource/icon/0x00160506.png");
// const Image143 = require("./resource/icon/0x00160506-1.png");
// const Image144 = require("./resource/icon/0x00160506-2.png");
// const Image145 = require("./resource/icon/0x00160513.png");
// const Image146 = require("./resource/icon/0x00160513-1.png");
// const Image147 = require("./resource/icon/0x00160513-2.png");
// const Image148 = require("./resource/icon/0x00160507.png");
// const Image149 = require("./resource/icon/0x00160507-1.png");
// const Image150 = require("./resource/icon/0x00160507-2.png");
// const Image151 = require("./resource/icon/0x0016050A.png");
// const Image152 = require("./resource/icon/0x0016050A-1.png");
// const Image153 = require("./resource/icon/0x0016050A-2.png");
// const Image154 = require("./resource/icon/0x02000307.png");
// const Image155 = require("./resource/icon/0x02000307-1.png");
// const Image156 = require("./resource/icon/0x02000307-2.png");
// const Image157 = require("./resource/icon/0x001E5003.png");
// const Image158 = require("./resource/icon/0x001E5003-1.png");
// const Image159 = require("./resource/icon/0x001E5003-2.png");
// const Image160 = require("./resource/icon/0x001e5002.png");
// const Image161 = require("./resource/icon/0x001e5002-1.png");
// const Image162 = require("./resource/icon/0x001e5002-2.png");
// const Image163 = require("./resource/icon/0x00160509.png");
// const Image164 = require("./resource/icon/0x00160509-1.png");
// const Image165 = require("./resource/icon/0x00160509-2.png");
// const Image166 = require("./resource/icon/0x001e5001.png");
// const Image167 = require("./resource/icon/0x001e5001-1.png");
// const Image168 = require("./resource/icon/0x001e5001-2.png");
// const Image169 = require("./resource/icon/0x00160508.png");
// const Image170 = require("./resource/icon/0x00160508-1.png");
// const Image171 = require("./resource/icon/0x00160508-2.png");
// const Image172 = require("./resource/icon/0x02000308.png");
// const Image173 = require("./resource/icon/0x02000308-1.png");
// const Image174 = require("./resource/icon/0x02000308-2.png");
// const Image175 = require("./resource/icon/0x00160518.png");
// const Image176 = require("./resource/icon/0x00160518-1.png");
// const Image177 = require("./resource/icon/0x00160518-2.png");
// const Image178 = require("./resource/icon/0x001E5005.png");
// const Image179 = require("./resource/icon/0x001E5005-1.png");
// const Image180 = require("./resource/icon/0x001E5005-2.png");
// const Image181 = require("./resource/icon/0x001E5004.png");
// const Image182 = require("./resource/icon/0x001E5004-1.png");
// const Image183 = require("./resource/icon/0x001E5004-2.png");
// const Image184 = require("./resource/icon/0x00160519.png");
// const Image185 = require("./resource/icon/0x00160519-1.png");
// const Image186 = require("./resource/icon/0x00160519-2.png");
// const Image187 = require("./resource/icon/0x00090601.png");
// const Image188 = require("./resource/icon/0x00090601-1.png");
// const Image189 = require("./resource/icon/0x00090601-2.png");
// const Image190 = require("./resource/icon/0x001E5006.png");
// const Image191 = require("./resource/icon/0x001E5006-1.png");
// const Image192 = require("./resource/icon/0x001E5006-2.png");
// const Image193 = require("./resource/icon/0x00100505.png");
// const Image194 = require("./resource/icon/0x00100505-1.png");
// const Image195 = require("./resource/icon/0x00100505-2.png");
// const Image196 = require("./resource/icon/0x2A010004.png");
// const Image197 = require("./resource/icon/0x2A010004-1.png");
// const Image198 = require("./resource/icon/0x2A010004-2.png");
// const Image199 = require("./resource/icon/0x2A010006.png");
// const Image200 = require("./resource/icon/0x2A010006-1.png");
// const Image201 = require("./resource/icon/0x2A010006-2.png");
// const Image202 = require("./resource/icon/0x00110503.png");
// const Image203 = require("./resource/icon/0x00110503-1.png");
// const Image204 = require("./resource/icon/0x00110503-2.png");
// const Image205 = require("./resource/icon/0x03000308.png");
// const Image206 = require("./resource/icon/0x03000308-1.png");
// const Image207 = require("./resource/icon/0x03000308-2.png");
// const Image208 = require("./resource/icon/0x0016051A_.png");
// const Image209 = require("./resource/icon/0x0016051A_-1.png");
// const Image210 = require("./resource/icon/0x0016051A_-2.png");
// const Image211 = require("./resource/icon/0x00193008.png");
// const Image212 = require("./resource/icon/0x00193008-1.png");
// const Image213 = require("./resource/icon/0x00193008-2.png");
// const Image214Relate = require("./resource/icon/0x00153006-relate.png");
// const Image214 = require("./resource/icon/0x00153006.png");
// const Image215 = require("./resource/icon/0x00153006-1.png");
// const Image216 = require("./resource/icon/0x00153006-2.png");
// const Image217Relate = require("./resource/img/panelSelectDefault.png");
// const Image217 = require("./resource/icon/default.png");
// const Image218 = require("./resource/icon/default-1.png");
// const Image219 = require("./resource/icon/default-2.png");
// const Image220 = require("./resource/icon/0x00110513.png");
// const Image221 = require("./resource/icon/0x00110513-1.png");
// const Image222 = require("./resource/icon/0x00110513-2.png");
// const Image223Relate = require("./resource/icon/0x00153007-relate.png");
// const Image223 = require("./resource/icon/0x00153007.png");
// const Image224 = require("./resource/icon/0x00153007-1.png");
// const Image225 = require("./resource/icon/0x00153007-2.png");
// const Image226Relate = require("./resource/icon/0x00153005-relate.png");
// const Image226 = require("./resource/icon/0x00153005.png");
// const Image227 = require("./resource/icon/0x00153005-1.png");
// const Image228 = require("./resource/icon/0x00153005-2.png");
// const Image229Relate = require("./resource/icon/0x00153004-relate.png");
// const Image229 = require("./resource/icon/0x00153004.png");
// const Image230 = require("./resource/icon/0x00153004-1.png");
// const Image231 = require("./resource/icon/0x00153004-2.png");
// const Image232 = require("./resource/icon/0x00140003.png");
// const Image233 = require("./resource/icon/0x00140003-1.png");
// const Image234 = require("./resource/icon/0x00140003-2.png");
// const Image235 = require("./resource/icon/0x00140001.png");
// const Image236 = require("./resource/icon/0x00140001-1.png");
// const Image237 = require("./resource/icon/0x00140001-2.png");
// const Image238 = require("./resource/icon/0x00140002.png");
// const Image239 = require("./resource/icon/0x00140002-1.png");
// const Image240 = require("./resource/icon/0x00140002-2.png");
// const Image241 = require("./resource/icon/0x000B0001.png");
// const Image242 = require("./resource/icon/0x000B0001-1.png");
// const Image243 = require("./resource/icon/0x000B0001-2.png");
// const Image244 = require("./resource/icon/0x2C010006.png");
// const Image245 = require("./resource/icon/0x2C010006-1.png");
// const Image246 = require("./resource/icon/0x2C010006-2.png");
// const Image247 = require("./resource/icon/0x2C010004.png");
// const Image248 = require("./resource/icon/0x2C010004-1.png");
// const Image249 = require("./resource/icon/0x2C010004-2.png");
// const Image250 = require("./resource/icon/0x2C010012.png");
// const Image251 = require("./resource/icon/0x2C010012-1.png");
// const Image252 = require("./resource/icon/0x2C010012-2.png");
// const Image253 = require("./resource/icon/0x2C020012.png");
// const Image254 = require("./resource/icon/0x2C020012-1.png");
// const Image255 = require("./resource/icon/0x2C020012-2.png");
// const Image256 = require("./resource/icon/0x2A010012.png");
// const Image257 = require("./resource/icon/0x2A010012-1.png");
// const Image258 = require("./resource/icon/0x2A010012-2.png");
// const Image259 = require("./resource/icon/0x2A020012.png");
// const Image260 = require("./resource/icon/0x2A020012-1.png");
// const Image261 = require("./resource/icon/0x2A020012-2.png");
// const Image262 = require("./resource/icon/0x000A0003.png");
// const Image263 = require("./resource/icon/0x000A0003-1.png");
// const Image264 = require("./resource/icon/0x000A0003-2.png");
// const Image265 = require("./resource/icon/0x001F0008.png");
// const Image266 = require("./resource/icon/0x001F0008-1.png");
// const Image267 = require("./resource/icon/0x001F0008-2.png");
// const Image268 = require("./resource/icon/0x2D020022.png");
// const Image269 = require("./resource/icon/0x2D020022-1.png");
// const Image270 = require("./resource/icon/0x2D020022-2.png");
// const Image271 = require("./resource/icon/0x001F0007.png");
// const Image272 = require("./resource/icon/0x001F0007-1.png");
// const Image273 = require("./resource/icon/0x001F0007-2.png");
// const Image274 = require("./resource/icon/0x0200030C.png");
// const Image275 = require("./resource/icon/0x0200030C-1.png");
// const Image276 = require("./resource/icon/0x0200030C-2.png");

// const icons = {
//   "0x00193007": {
//     "relate": Image223Relate,
//     "on": Image1,
//     "offLine": Image2,
//     "off": Image3
//   },
//   "0x00210003": {
//     "on": Image4,
//     "offLine": Image5,
//     "off": Image6
//   },
//   "0x001F0005": {
//     "on": Image7,
//     "offLine": Image8,
//     "off": Image9
//   },
//   "0x001F0004": {
//     "relate": Image223Relate,
//     "on": Image10,
//     "offLine": Image11,
//     "off": Image12
//   },
//   "0x00010904": {
//     "on": Image13,
//     "offLine": Image14,
//     "off": Image15
//   },
//   "0x00210002": {
//     "on": Image16,
//     "offLine": Image17,
//     "off": Image18
//   },
//   "0x02000201": {
//     "on": Image19,
//     "offLine": Image20,
//     "off": Image21
//   },
//   "0x00193006": {
//     "relate": Image214Relate,
//     "on": Image22,
//     "offLine": Image23,
//     "off": Image24
//   },
//   "0x03000302": {
//     "on": Image25,
//     "offLine": Image26,
//     "off": Image27
//   },
//   "0x00160519_": {
//     "on": Image28,
//     "offLine": Image29,
//     "off": Image30
//   },
//   "0x02000203": {
//     "on": Image31,
//     "offLine": Image32,
//     "off": Image33
//   },
//   "0x001F0006": {
//     "on": Image34,
//     "offLine": Image35,
//     "off": Image36
//   },
//   "0x001A3002": {
//     "on": Image37,
//     "offLine": Image38,
//     "off": Image39
//   },
//   "0x00210001": {
//     "on": Image40,
//     "offLine": Image41,
//     "off": Image42
//   },
//   "0x02000202": {
//     "on": Image43,
//     "offLine": Image44,
//     "off": Image45
//   },
//   "0x00193005": {
//     "relate": Image226Relate,
//     "on": Image46,
//     "offLine": Image47,
//     "off": Image48
//   },
//   "0x03000301": {
//     "on": Image49,
//     "offLine": Image50,
//     "off": Image51
//   },
//   "0x00193001": {
//     "on": Image52,
//     "offLine": Image53,
//     "off": Image54
//   },
//   "0x03000305": {
//     "relate": Image229Relate,
//     "on": Image55,
//     "offLine": Image56,
//     "off": Image57
//   },
//   "0x02000206": {
//     "on": Image58,
//     "offLine": Image59,
//     "off": Image60
//   },
//   "0x00010903": {
//     "on": Image61,
//     "offLine": Image62,
//     "off": Image63
//   },
//   "0x001F0003": {
//     "relate": Image229Relate,
//     "on": Image64,
//     "offLine": Image65,
//     "off": Image66
//   },
//   "0x001F0002": {
//     "on": Image67,
//     "offLine": Image68,
//     "off": Image69
//   },
//   "0x00010902": {
//     "on": Image70,
//     "offLine": Image71,
//     "off": Image72
//   },
//   "0x03000304": {
//     "on": Image73,
//     "offLine": Image74,
//     "off": Image75
//   },
//   "0x03000306": {
//     "relate": Image229Relate,
//     "on": Image76,
//     "offLine": Image77,
//     "off": Image78
//   },
//   "0x02000205": {
//     "on": Image79,
//     "offLine": Image80,
//     "off": Image81
//   },
//   "0x00010900": {
//     "on": Image82,
//     "offLine": Image83,
//     "off": Image84
//   },
//   "0x001F0001": {
//     "on": Image85,
//     "offLine": Image86,
//     "off": Image87
//   },
//   "0x00010901": {
//     "on": Image88,
//     "offLine": Image89,
//     "off": Image90
//   },
//   "0x02000204": {
//     "on": Image91,
//     "offLine": Image92,
//     "off": Image93
//   },
//   "0x03000307": {
//     "on": Image94,
//     "offLine": Image95,
//     "off": Image96
//   },
//   "0x02000303": {
//     "on": Image97,
//     "offLine": Image98,
//     "off": Image99
//   },
//   "0x0016051A": {
//     "on": Image100,
//     "offLine": Image101,
//     "off": Image102
//   },
//   "0x0016050D": {
//     "on": Image103,
//     "offLine": Image104,
//     "off": Image105
//   },
//   "0x00160502": {
//     "on": Image106,
//     "offLine": Image107,
//     "off": Image108
//   },
//   "0x02000302": {
//     "relate": Image121Relate,
//     "on": Image109,
//     "offLine": Image110,
//     "off": Image111
//   },
//   "0x0016051B": {
//     "on": Image112,
//     "offLine": Image113,
//     "off": Image114
//   },
//   "0x0016050F": {
//     "on": Image115,
//     "offLine": Image116,
//     "off": Image117
//   },
//   "0x00160501": {
//     "on": Image118,
//     "offLine": Image119,
//     "off": Image120
//   },
//   "0x02000301": {
//     "relate": Image121Relate,
//     "on": Image121,
//     "offLine": Image122,
//     "off": Image123
//   },
//   "0x0016050C": {
//     "on": Image124,
//     "offLine": Image125,
//     "off": Image126
//   },
//   "0x00160511": {
//     "on": Image127,
//     "offLine": Image128,
//     "off": Image129
//   },
//   "0x00160510": {
//     "on": Image130,
//     "offLine": Image131,
//     "off": Image132
//   },
//   "0x0016050B": {
//     "on": Image133,
//     "offLine": Image134,
//     "off": Image135
//   },
//   "0x001C3003": {
//     "on": Image136,
//     "offLine": Image137,
//     "off": Image138
//   },
//   "0x02000306": {
//     "relate": Image226Relate,
//     "on": Image139,
//     "offLine": Image140,
//     "off": Image141
//   },
//   "0x00160506": {
//     "on": Image142,
//     "offLine": Image143,
//     "off": Image144
//   },
//   "0x00160513": {
//     "on": Image145,
//     "offLine": Image146,
//     "off": Image147
//   },
//   "0x00160507": {
//     "on": Image148,
//     "offLine": Image149,
//     "off": Image150
//   },
//   "0x0016050A": {
//     "on": Image151,
//     "offLine": Image152,
//     "off": Image153
//   },
//   "0x02000307": {
//     "relate": Image214Relate,
//     "on": Image154,
//     "offLine": Image155,
//     "off": Image156
//   },
//   "0x001E5003": {
//     "on": Image157,
//     "offLine": Image158,
//     "off": Image159
//   },
//   "0x001e5002": {
//     "on": Image160,
//     "offLine": Image161,
//     "off": Image162
//   },
//   "0x00160509": {
//     "on": Image163,
//     "offLine": Image164,
//     "off": Image165
//   },
//   "0x001e5001": {
//     "on": Image166,
//     "offLine": Image167,
//     "off": Image168
//   },
//   "0x00160508": {
//     "on": Image169,
//     "offLine": Image170,
//     "off": Image171
//   },
//   "0x02000308": {
//     "relate": Image223Relate,
//     "on": Image172,
//     "offLine": Image173,
//     "off": Image174
//   },
//   "0x00160518": {
//     "on": Image175,
//     "offLine": Image176,
//     "off": Image177
//   },
//   "0x001E5005": {
//     "on": Image178,
//     "offLine": Image179,
//     "off": Image180
//   },
//   "0x001E5004": {
//     "on": Image181,
//     "offLine": Image182,
//     "off": Image183
//   },
//   "0x00160519": {
//     "on": Image184,
//     "offLine": Image185,
//     "off": Image186
//   },
//   "0x00090601": {
//     "on": Image187,
//     "offLine": Image188,
//     "off": Image189
//   },
//   "0x001E5006": {
//     "on": Image190,
//     "offLine": Image191,
//     "off": Image192
//   },
//   "0x00100505": {
//     "on": Image193,
//     "offLine": Image194,
//     "off": Image195
//   },
//   "0x00100506": {
//     "on": Image193,
//     "offLine": Image194,
//     "off": Image195
//   },
//   "0x2A010004": {
//     "on": Image196,
//     "offLine": Image197,
//     "off": Image198
//   },
//   "0x2A010006": {
//     "on": Image199,
//     "offLine": Image200,
//     "off": Image201
//   },
//   "0x00110503": {
//     "on": Image202,
//     "offLine": Image203,
//     "off": Image204
//   },
//   "0x03000308": {
//     "on": Image205,
//     "offLine": Image206,
//     "off": Image207
//   },
//   "0x0016051A_": {
//     "on": Image208,
//     "offLine": Image209,
//     "off": Image210
//   },
//   "0x00193008": {
//     "on": Image211,
//     "offLine": Image212,
//     "off": Image213
//   },
//   "0x00153006": {
//     "relate": Image214Relate,
//     "on": Image214,
//     "offLine": Image215,
//     "off": Image216
//   },
//   "default": {
//     "relate": Image217Relate,
//     "on": Image217,
//     "offLine": Image218,
//     "off": Image219
//   },
//   "0x00110513": {
//     "on": Image220,
//     "offLine": Image221,
//     "off": Image222
//   },
//   "0x00153007": {
//     "relate": Image223Relate,
//     "on": Image223,
//     "offLine": Image224,
//     "off": Image225
//   },
//   "0x00153005": {
//     "relate": Image226Relate,
//     "on": Image226,
//     "offLine": Image227,
//     "off": Image228
//   },
//   "0x00153004": {
//     "relate": Image229Relate,
//     "on": Image229,
//     "offLine": Image230,
//     "off": Image231
//   },
//   "0x2A020006": {
//     "on": Image199,
//     "offLine": Image200,
//     "off": Image201
//   },
//   "0x0200030B": {
//     "relate": Image223Relate,
//     "on": Image223,
//     "offLine": Image224,
//     "off": Image225
//   },
//   "0x0200030A": {
//     "relate": Image214Relate,
//     "on": Image214,
//     "offLine": Image215,
//     "off": Image216
//   },
//   "0x02000309": {
//     "relate": Image226Relate,
//     "on": Image226,
//     "offLine": Image227,
//     "off": Image228
//   },
//   "0x00140003": {
//     "on": Image232,
//     "offLine": Image233,
//     "off": Image234
//   },
//   "0x00140001": {
//     "on": Image235,
//     "offLine": Image236,
//     "off": Image237
//   },
//   "0x00140002": {
//     "on": Image235,
//     "offLine": Image236,
//     "off": Image237
//   },
//   "0x00140004": {
//     "on": Image238,
//     "offLine": Image239,
//     "off": Image240
//   },
//   "0x000B0001": {
//     "on": Image241,
//     "offLine": Image242,
//     "off": Image243
//   },
//   "0x2C010006": {
//     "on": Image244,
//     "offLine": Image245,
//     "off": Image246
//   },
//   "0x2C010004": {
//     "on": Image247,
//     "offLine": Image248,
//     "off": Image249
//   },
//   "0x2C010012": {
//     "on": Image250,
//     "offLine": Image251,
//     "off": Image252
//   },
//   "0x2C020012": {
//     "on": Image253,
//     "offLine": Image254,
//     "off": Image255
//   },
//   "0x2A010012": {
//     "on": Image256,
//     "offLine": Image257,
//     "off": Image258
//   },
//   "0x2A020012": {
//     "on": Image259,
//     "offLine": Image260,
//     "off": Image261
//   },
//   "0x000A0003": {
//     "on": Image262,
//     "offLine": Image263,
//     "off": Image264
//   },
//   "0x001F0008": {
//     "on": Image265,
//     "offLine": Image266,
//     "off": Image267
//   },
//   "0x2D020022": {
//     "on": Image268,
//     "offLine": Image269,
//     "off": Image270
//   },
//   "0x001F0007": {
//     "on": Image271,
//     "offLine": Image272,
//     "off": Image273
//   },
//   "0x0200030C": {
//     "on": Image274,
//     "offLine": Image275,
//     "off": Image276
//   },
// }

function getDeviceIcon(sku) {
  // return icons[sku]?icons[sku]:icons["default"];
  return getTuiOppleDeviceIcon(sku);
}
module.exports = getDeviceIcon
var script = document.createElement("script");
script.type = "text/javascript";
script.src = "/static/@opple/commercial-lighting-resource/JS/Icons_local.js";
document.body.appendChild(script);
script = null;
